import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {useEvents} from "../../../lib/useEvents";

export function useDeleteSirenEmailBranding() {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {emit} = useEvents();

    const deleteBranding = useCallback(async (id: string, context?: {clientID?: string; departmentID?: string}) => {
        setDeleting(true);
        setError(null);
        try {
            await platformAPI.delete(`api/siren/email-branding/${id}`);
            emit("siren:emailBranding:changed", {clientID: context?.clientID, departmentID: context?.departmentID, deleted: true});
        } catch {
            setError("Failed to delete siren email branding");
            throw new Error("Failed to delete siren email branding");
        } finally {
            setDeleting(false);
        }
    }, [emit]);

    return {deleteBranding, deleting, error};
}
